// QualificationDropdown.jsx
import React, { useEffect, useState } from "react";

const QualificationDropdown = ({ label, name, options, onChange, labelStyle, errId, fieldId, isRequired, caseId, caseCheckId, isReadonly, id, value , nomineeIndex, nomineeFieldIdx}) => {

  const[option, setOption] = useState([]);

  useEffect(() => {
    if(!options.length > 0){
      const optionsArray = Object.entries(options).map(([key, value]) => {
        // return { [key] : value };
        return { label: key, value: value };

      });
      setOption(optionsArray);
    }else{
      setOption(options);
    }
    },[options])

  const handleChange = (e) => {
    onChange([{ "name": name, "value": e.target.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseId": caseId, "caseCheckId": caseCheckId, "isReadonly": isReadonly, 'id' : id , 'nomineeFieldIdx' : nomineeFieldIdx, 'nomineeIndex' : nomineeIndex}]);

  }

  return (
    <div className="form-group">
      <div className="floating-label tp-dropdown">
        <select className="form-control" onChange={handleChange} value={value}>
          <option value="">Select option</option>
          {option && option.map((item, index) => (
            <option key={index} value={item.value || item}>
              {item.value || item}
            </option>
            // <></>
          ))}
        </select>
        <label style={labelStyle} className="focused">
          {label} { isRequired && <sup className="text-danger">*</sup>}
        </label>
      </div>
      <p className="err text-danger" id={errId}></p>
      <input type="hidden" />
    </div>
  );
};

export default QualificationDropdown;
